<template>
  <div>
    <div class="buttons_box">
      <router-link
        :to="{ name: backButtonDestination }"
        data-test-id="button-previous-step"
        v-if="showPrevButton && step !== 7 && step !== 8"
        class="bb_button button_back"
        :class="backButtonClass"
        :id="dynamicIdBackButton"
        >{{ backButtonText }}</router-link
      >
      <a
        v-if="step === 7 || step === 8"
        :href="exitUrl"
        class="bb_button button_back"
        >Return to website</a
      >
      <button
        data-test-id="button-next-step"
        v-if="step === 4 || step === 1"
        v-on:click="goNext"
        class="bb_button button_next"
        :disabled="!nextButtonEnabled"
        :id="dynamicIdNextButton"
      >
        {{ nextButtonText }}
      </button>
      <router-link
        :to="{ name: nextButtonDestination }"
        data-test-id="button-next-step"
        v-if="showNextButton"
        class="bb_button button_next"
        :class="{ disabled: !nextButtonEnabled }"
        :disabled="!nextButtonEnabled"
        :id="dynamicIdNextButton"
        >{{ nextButtonText }}</router-link
      >
    </div>
    <confirmation-popup
      v-show="confirmationPopupShown"
      v-on:hideConfirmationPopup="hideConfirmationPopup"
      v-on:confirmSubmission="confirmSubmission"
    />
  </div>
</template>

<script>
import ConfirmationPopup from "@/components/ConfirmationPopup.vue";
export default {
  components: {
    confirmationPopup: ConfirmationPopup,
  },
  props: {
    step: {
      type: Number,
      default: 0,
    },
    nextButtonEnabled: {
      type: Boolean,
      default: false,
    },
    exitUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showNextButton: true,
      confirmationPopupShown: false,
    };
  },
  computed: {
    nextButtonText: function nextButtonText() {
      var text = "Next";
      if (this.step === 1) {
        text = "See if I'm eligible";
      } else if (this.step === 2) {
        text = "Next: Finance Details";
      } else if (this.step === 3) {
        text = "Next: Your Details";
      } else if (this.step === 4) {
        text = "Submit application";
      } else if (this.step === 7) {
        text = "Provide additional information";
      }
      return text;
    },
    showPrevButton: function showPrevButton() {
      const steps_with_prev_button = [1, 3, 4];
      return steps_with_prev_button.indexOf(this.step) > -1;
    },
    backButtonText: function backButtonText() {
      if (this.step === 7 || this.step === 8) {
        return "Return to website";
      } else {
        return "Back";
      }
    },
    backButtonDestination: function backButtonDestination() {
      switch (this.step) {
        case 1:
          return "index";
          break;
        case 3:
          return "farm-details";
          break;
        case 4:
          return "finance-details";
          break;
        default:
          return "";
      }
    },
    nextButtonDestination: function nextButtonDestination() {
      switch (this.step) {
        case 0:
          return "check-eligibility";
          break;
        case 1:
          return "farm-details";
          break;
        case 2:
          return "finance-details";
          break;
        case 3:
          return "your-details";
          break;
        default:
          return "";
      }
    },
    backButtonClass: function backButtonClass() {
      if (this.step === 7 || this.step === 8) {
        return "close_app_button";
      } else {
        return "";
      }
    },
    dynamicIdBackButton: function dynamicIdBackButton() {
      switch (this.step) {
        case 1:
          return `tracking__${window.trackingCode}__eligibility-screen-2__back`;
        case 3:
          return `tracking__${window.trackingCode}__finance-screen__back`;
        case 4:
          return `tracking__${window.trackingCode}__your-details-screen__back`;
        case 7:
          return `tracking__${window.trackingCode}__approval-screen__close-app`;
        case 8:
          return `tracking__${window.trackingCode}__approval-screen__close-app`;
        default:
          return "";
      }
    },
    dynamicIdNextButton: function dynamicIdNextButton() {
      switch (this.step) {
        case 0:
          return `tracking__${window.trackingCode}__eligibility-screen-1__next`;
        case 1:
          return `tracking__${window.trackingCode}__eligibility-screen-2__see-if-eligible`;
        case 2:
          return `tracking__${window.trackingCode}__farm-screen__next-finance-details`;
        case 3:
          return `tracking__${window.trackingCode}__finance-screen__next-your-details`;
        case 4:
          return `tracking__${window.trackingCode}__your-details-screen__submit-app`;
        default:
          return "";
      }
    },
    returnToWebsite: function returnToWebsite() {
      return this.exitUrl; // process.env.RETURN_URL;
    },
  },
  watch: {
    step: {
      handler(val) {
        if ([1, 4, 5, 6, 7, 8].indexOf(val) > -1) {
          this.showNextButton = false;
        } else {
          this.showNextButton = true;
        }
      },
    },
  },
  created: function() {
    if ([4, 5, 6, 7, 8].indexOf(this.step) > -1) {
      this.showNextButton = false;
    } else {
      this.showNextButton = true;
    }
  },
  methods: {
    //#pjw not used ?
    goBack: function goBack() {
      if (this.step === 7 || this.step === 8) {
        window.location.href = this.exitUrl; //process.env.RETURN_URL;
      } else {
        this.$emit("stepBack", this.step);
      }
    },
    goNext: function goNext() {
      if (this.step === 1) {
        this.$emit("checkEligibility");
      } else if (this.step === 4) {
        this.confirmationPopupShown = true;
      } else if (this.step === 7 || this.step === 8) {
        //   last step?
      } else {
        this.$emit("stepNext", this.step);
      }
    },
    hideConfirmationPopup: function hideConfirmationPopup() {
      this.confirmationPopupShown = false;
    },
    confirmSubmission: function confirmSubmission() {
      this.confirmationPopupShown = false;
      this.$emit("submitApplication");
    },
  },
};
</script>
